import { render } from "./projectsList.vue?vue&type=template&id=db576daa&ts=true"
import script from "./projectsList.vue?vue&type=script&lang=ts"
export * from "./projectsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__